import { ColDef, themeAlpine } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React, { useMemo } from "react";

import { IgPaper, IgTableWrapper, IgTypography } from "@intelligems/ig-theme";
import { FullAgencyDto } from "@intelligems/ig-types";
import { AgencyCustomerDto } from "@intelligems/ig-types/dtos/agency-customers";
import { Grid } from "@mui/material";
import { DeleteColumn } from "@src/features/admin/pages/agencies/components/Tables/AgencyCustomersTable/renderers/DeleteColumn";
import { ViewColumn } from "@src/features/admin/pages/agencies/components/Tables/AgencyCustomersTable/renderers/ViewColumn";
import { theme } from "@src/theme";

interface StripeCustomerTableProps {
  agency: FullAgencyDto;
}

const myTheme = themeAlpine.withParams({
  fontFamily: theme.typography.fontFamily,
});

export const AgencyCustomersTable = ({ agency }: StripeCustomerTableProps) => {
  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
      suppressHeaderMenuButton: true,
      suppressHeaderContextMenu: true,
    };
  }, []);

  const columnDefs: ColDef<AgencyCustomerDto & { "": "" }>[] = useMemo(
    () => [
      {
        headerName: "Name",
        field: "name",
        sortable: true,
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Email",
        field: "email",
        sortable: true,
        filter: "agTextColumnFilter",
        valueGetter: (params) => {
          return params.data?.email || "-";
        },
      },
      {
        headerName: "Active Subscriptions",
        field: "",
        valueGetter: (params) => {
          return (params.context.agency as FullAgencyDto).subscriptions.filter(
            (sub) => sub.stripeCustomerId === params.data?.stripeCustomerId
          ).length;
        },
      },
      {
        headerName: "",
        field: "",
        cellRenderer: ViewColumn,
      },
      {
        headerName: "",
        field: "",
        cellRenderer: DeleteColumn,
        cellStyle: { justifyContent: "end" },
        maxWidth: 70,
      },
    ],
    []
  );

  if (!agency.customers.length) {
    return (
      <Grid item textAlign={{ textAlign: "center" }}>
        <IgTypography variant={"body2"}>
          No customers assigned to this agency
        </IgTypography>
      </Grid>
    );
  }

  return (
    // <IgPaper sx={{ boxShadow: "none" }}>
    <Grid item>
      <IgTableWrapper minHeight={"100px"} height={null}>
        <AgGridReact<AgencyCustomerDto>
          theme={myTheme}
          rowData={agency.customers}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          headerHeight={25}
          domLayout={"autoHeight"}
          context={{ agency }}
          detailRowAutoHeight={true}
          suppressCellFocus={true}
          suppressRowHoverHighlight={true}
        />
      </IgTableWrapper>
    </Grid>
    // </IgPaper>
  );
};
